import React from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import Loading from "../../../components/Loading";

dayjs.extend(relativeTime);

const PendingReplies = ({ pendingReplies, loading }) => {
  if (loading) return <div className="recap-card"><Loading type="small" /></div>;

  return (
    <div className="recap-card">
      <div className="recap-card__header">
        <h3 className="recap-card__title">Pending Replies</h3>
        <span className="recap-card__stat-value recap-card__stat-value--accent">
          {pendingReplies.length}
        </span>
      </div>

      <p className="recap-card__subtitle">
        Direct messages awaiting your reply (last 24h)
      </p>

      {pendingReplies.length === 0 ? (
        <p className="recap-card__empty">All caught up — no pending replies</p>
      ) : (
        <div className="recap-card__list recap-card__list--scrollable">
          {pendingReplies.map((msg, i) => {
            const waitTime = dayjs.unix(msg.timestamp).fromNow();
            return (
              <div key={i} className="recap-card__list-item">
                <div className="recap-card__list-item-content">
                  <span className="recap-card__list-item-name">
                    {msg.sender?.wa_name || msg.sender?.phone || msg.chat_title}
                  </span>
                  <span className="recap-card__list-item-sub">
                    {msg.message_text?.substring(0, 60)}
                    {msg.message_text?.length > 60 ? "..." : ""}
                  </span>
                </div>
                <span className="recap-card__time-ago">{waitTime}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PendingReplies;
